import React, { useState, useContext } from 'react';
import axios from 'axios';
import {
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionPanel,
  AccordionIcon,
  Box,
  Flex,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Button,
  useDisclosure,
  Drawer,
  DrawerOverlay,
  DrawerContent,
  DrawerHeader,
  DrawerCloseButton,
  DrawerBody,
  FormControl,
  FormLabel,
  Input,
  DrawerFooter,
  TableContainer,
  Heading,
  Grid,
} from '@chakra-ui/react';
import { MyContext } from '../../MyProvider';
import AdminLogin from "../AdminNav/Login";
import { Link } from 'react-router-dom';

import { PageHeader } from "../../components/ui";
import { API_URL } from "../../Apis/config";

const Employee = () => {
  const { assigneeData, assigneeApi, eventData } = useContext(MyContext);
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [newEmployee, setNewEmployee] = useState({ name: '', mobile: '' });
  const [fromDate, setFromDate] = useState('');
  const [toDate, setToDate] = useState('');

  const token = localStorage.getItem("AdminToken");
  if (!token) {
    return <AdminLogin />;
  }

  // Handle Input Change
  const handleChange = (e) => {
    setNewEmployee({ ...newEmployee, [e.target.name]: e.target.value });
  };

  const handleDateChange = (e) => {
    const { name, value } = e.target;
    if (name === 'fromDate') {
      setFromDate(value);
    } else if (name === 'toDate') {
      setToDate(value);
    }
  };

  // Add Employee
  const addEmployee = async () => {
    try {
      const response = await axios.post(`${API_URL}/assignee/`, newEmployee);
      assigneeApi();
      onClose(); // Close the modal
      setNewEmployee({ name: '', mobile: '' }); // Reset form
    } catch (error) {
      console.error('Error adding employee:', error);
    }
  };

  // Filter events by date range
  const filterEventsByDate = (events) => {
    const from = fromDate ? new Date(fromDate.split('/').reverse().join('-')) : null;
    const to = toDate ? new Date(toDate.split('/').reverse().join('-')) : null;

    return events.filter((event) => {
      const eventDate = new Date(event.eventDate.split('/').reverse().join('-'));
      return (!from || eventDate >= from) && (!to || eventDate <= to);
    });
  };

  return (
    <>
      <PageHeader title="Employees" subtitle={`${assigneeData.length} on the team`}>
        <Button onClick={onOpen}>Add Employee</Button>
      </PageHeader>
      <Flex gap={3} wrap="wrap" mb={5}>
        <FormControl w={{ base: "100%", md: "200px" }}>
          <FormLabel>From</FormLabel>
          <Input type="date" name="fromDate" value={fromDate} onChange={handleDateChange} />
        </FormControl>
        <FormControl w={{ base: "100%", md: "200px" }}>
          <FormLabel>To</FormLabel>
          <Input type="date" name="toDate" value={toDate} onChange={handleDateChange} />
        </FormControl>
      </Flex>
      <Grid templateColumns="repeat(4, 1fr)" px={4} pr={10} py={2.5} fontWeight={600} color="kumkum.700" bg="kumkum.50" borderBottom="2px solid" borderColor="kumkum.500" borderTopRadius="lg">
        <Box p={2}>Name</Box>
        <Box p={2}>Mobile</Box>
        <Box p={2}>Events</Box>
        <Box p={2}>Total paid</Box>
      </Grid>
      <Accordion allowToggle bg="white" borderBottomRadius="lg" border="1px solid" borderTop="none" borderColor="stone.200" overflow="hidden">
        {assigneeData.map((employee) => (
          <AccordionItem key={employee._id}>
            <h2>
              <AccordionButton>
              <Grid templateColumns="repeat(4, 1fr)" width="100%">
                  <Box textAlign="left" p={2}>
                    {employee.name}
                  </Box>
                  <Box textAlign="left" p={2}>
                    {employee.mobile}
                  </Box>
                  <Box textAlign="left" p={2}>
                    {filterEventsByDate(eventData).filter((eve) =>
                      eve.assignees.find((obj) => obj._id === employee._id && obj.assigned)
                    ).length}
                  </Box>
                  <Box textAlign="left" p={2}>
                    {filterEventsByDate(eventData)
                      .filter((eve) =>
                        eve.assignees.find((obj) => obj._id === employee._id && obj.assigned)
                      )
                      .reduce((sum, event) => {
                        const assi = event.assignees.find(
                          (ass) => ass._id === employee._id && ass.assigned
                        );
                        return sum + (assi ? (assi.eamount ? assi.eamount : 0) : 0);
                      }, 0)}
                  </Box>
                </Grid>
                <AccordionIcon />
              </AccordionButton>
            </h2>
            <AccordionPanel pb={4}>
              {filterEventsByDate(eventData).filter((eve) =>
                eve.assignees.find((obj) => obj._id === employee._id && obj.assigned)
              ).length > 0 ? (
                <TableContainer>
                  <Table variant="simple">
                    <Thead>
                      <Tr>
                        <Th>Event Date</Th>
                        <Th>Event Name</Th>
                        <Th>Full Name</Th>
                        <Th>Amount</Th>
                        <Th>Actions</Th>
                      </Tr>
                    </Thead>
                    <Tbody>
                      {filterEventsByDate(eventData).filter((eve) =>
                        eve.assignees.find((obj) => obj._id === employee._id && obj.assigned)
                      ).map((event) => (
                        <Tr key={event._id}>
                          <Td>{event.eventDate}</Td>
                          <Td>{event.eventName}</Td>
                          <Td>{event.fname} {event.lname}</Td>
                          <Td>
                            {event.assignees.find((ass) => ass._id === employee._id && ass.assigned)?.eamount || 0}
                          </Td>
                          <Td>
                          <Link to={`/admin/usersDtails/${event.userId}`}>
                            <Button variant="outline" size="sm" size="sm">
                              View User
                            </Button>
                            </Link>
                          </Td>
                        </Tr>
                      ))}
                    </Tbody>
                  </Table>
                </TableContainer>
              ) : (
                <Box color="stone.500">No events for this employee in these dates.</Box>
              )}
            </AccordionPanel>
          </AccordionItem>
        ))}
      </Accordion>

      <Drawer size="md"
        isOpen={isOpen}
        onClose={() => {
          onClose();
          setNewEmployee({ name: '', mobile: '' });
        }}
      >
        <DrawerOverlay />
        <DrawerContent>
          <DrawerHeader>
            Add employee
          </DrawerHeader>
          <DrawerCloseButton />
          <DrawerBody pb={6}>
            <FormControl isRequired>
              <FormLabel>Name</FormLabel>
              <Input
                name="name"
                value={newEmployee.name}
                onChange={handleChange}
                placeholder="Name"
              />
            </FormControl>

            <FormControl mt={4} isRequired>
              <FormLabel>Mobile</FormLabel>
              <Input
                name="mobile"
                value={newEmployee.mobile}
                onChange={handleChange}
                placeholder="Mobile Number"
              />
            </FormControl>
          </DrawerBody>

          <DrawerFooter>
            <Button mr={3} onClick={addEmployee} isDisabled={!newEmployee.name.trim() || !newEmployee.mobile.trim()}>
              Save
            </Button>
            <Button variant="ghost"
              onClick={() => {
                onClose();
                setNewEmployee({ name: '', mobile: '' });
              }}
            >
              Cancel
            </Button>
          </DrawerFooter>
        </DrawerContent>
      </Drawer>
    </>
  );
};

export default Employee;
